import { useEffect, useState } from 'react';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:8000') + '/api/personel';
const token = () => localStorage.getItem('token');
const hdr = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` });

const IZIN_TUR: Record<string, { label: string; renk: string; bg: string; ikon: string; mevzuat: string }> = {
  yillik:       { label: 'Yıllık İzin',          renk: '#1e40af', bg: '#dbeafe', ikon: '🏖️', mevzuat: '657 md.102' },
  hastalik:     { label: 'Hastalık İzni',         renk: '#991b1b', bg: '#fee2e2', ikon: '🏥', mevzuat: '657 md.105' },
  mazeret:      { label: 'Mazeret İzni',          renk: '#065f46', bg: '#d1fae5', ikon: '📋', mevzuat: '657 md.104' },
  dogum:        { label: 'Doğum İzni',            renk: '#6b21a8', bg: '#f5f3ff', ikon: '👶', mevzuat: '657 md.104/A' },
  babalik:      { label: 'Babalık İzni',          renk: '#1e40af', bg: '#e0f2fe', ikon: '👨', mevzuat: '657 md.104/B' },
  ucretsiz:     { label: 'Ücretsiz İzin',         renk: '#92400e', bg: '#fef3c7', ikon: '⏸️', mevzuat: '657 md.108' },
  resmi_tatil:  { label: 'Resmi Tatil',           renk: '#374151', bg: '#f3f4f6', ikon: '🎉', mevzuat: '2429 SK' },
};

const ONAY_DURUM: Record<string, { label: string; renk: string; bg: string }> = {
  beklemede:  { label: 'Beklemede',    renk: '#92400e', bg: '#fef3c7' },
  onaylandi:  { label: 'Onaylandı',    renk: '#065f46', bg: '#d1fae5' },
  reddedildi: { label: 'Reddedildi',  renk: '#991b1b', bg: '#fee2e2' },
};

const BOŞ_IZIN = {
  personel_id: '', izin_turu: 'yillik',
  baslama_tarihi: '', bitis_tarihi: '', gun_sayisi: 0,
  vekil_adi: '', aciklama: '',
};

export default function PersonelIzin() {
  const [liste, setListe] = useState<any[]>([]);
  const [personeller, setPersoneller] = useState<any[]>([]);
  const [bakiye, setBakiye] = useState<any>(null);
  const [form, setForm] = useState<any>(null);
  const [filtre, setFiltre] = useState({ personel_id: '', izin_turu: '', onay_durum: '' });

  useEffect(() => {
    yukle();
    fetch(`${API}/?durum=aktif`, { headers: hdr() }).then(r => r.json()).then(setPersoneller);
  }, []);

  function yukle(f = filtre) {
    const p = new URLSearchParams();
    if (f.personel_id) p.set('personel_id', f.personel_id);
    if (f.izin_turu)   p.set('izin_turu', f.izin_turu);
    if (f.onay_durum)  p.set('onay_durum', f.onay_durum);
    fetch(`${API}/izin/liste?${p}`, { headers: hdr() }).then(r => r.json()).then(setListe);
  }

  function filtreDegistir(k: string, v: string) {
    const yeni = { ...filtre, [k]: v };
    setFiltre(yeni);
    yukle(yeni);
    if (k === 'personel_id' && v) {
      fetch(`${API}/izin/bakiye/${v}?yil=${new Date().getFullYear()}`, { headers: hdr() })
        .then(r => r.json()).then(setBakiye);
    } else if (k === 'personel_id') setBakiye(null);
  }

  function gunHesapla(bas: string, bit: string) {
    if (!bas || !bit) return 0;
    const d1 = new Date(bas), d2 = new Date(bit);
    return Math.round((d2.getTime() - d1.getTime()) / 86400000) + 1;
  }

  async function kaydet() {
    if (!form.personel_id) return alert('Personel seçiniz');
    if (!form.baslama_tarihi || !form.bitis_tarihi) return alert('Tarih aralığını giriniz');
    const method = form.id ? 'PUT' : 'POST';
    const url = form.id ? `${API}/izin/${form.id}` : `${API}/izin`;
    const veri = { ...form, personel_id: Number(form.personel_id), gun_sayisi: Number(form.gun_sayisi) };
    await fetch(url, { method, headers: hdr(), body: JSON.stringify(veri) });
    setForm(null);
    yukle();
    if (filtre.personel_id) filtreDegistir('personel_id', filtre.personel_id);
  }

  async function onayla(id: number) {
    await fetch(`${API}/izin/${id}/onayla`, { method: 'POST', headers: hdr() });
    yukle();
    if (filtre.personel_id) filtreDegistir('personel_id', filtre.personel_id);
  }

  async function reddet(id: number) {
    await fetch(`${API}/izin/${id}/reddet`, { method: 'POST', headers: hdr() });
    yukle();
  }

  const bekleyenSayi = liste.filter(i => i.onay_durum === 'beklemede').length;
  const buAy = new Date().toISOString().slice(0, 7);
  const buAyIzin = liste.filter(i => i.baslama_tarihi?.startsWith(buAy)).length;

  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#111827' }}>İzin Yönetimi</h2>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: '#6b7280' }}>657 md.102-108 · Yıllık, Hastalık, Mazeret, Doğum, Ücretsiz İzinler</p>
        </div>
        <button onClick={() => setForm({ ...BOŞ_IZIN })} style={{
          background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 8,
          padding: '10px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 14,
        }}>+ İzin Talebi Ekle</button>
      </div>

      {/* ÖZET KARTLAR */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 20 }}>
        <OzetKart label="Toplam İzin" deger={liste.length} renk="#374151" bg="#f9fafb" />
        <OzetKart label="Bekleyen Onay" deger={bekleyenSayi} renk="#92400e" bg="#fef3c7" />
        <OzetKart label="Bu Ay" deger={buAyIzin} renk="#1d4ed8" bg="#eff6ff" />
        {bakiye ? (
          <div style={{ background: '#ecfdf5', borderRadius: 10, padding: '12px 16px', border: '1px solid #d1fae5' }}>
            <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>Seçili Personel — {bakiye.yil} Yıllık İzin</div>
            <div style={{ display: 'flex', gap: 16 }}>
              <span style={{ fontSize: 11, color: '#6b7280' }}>Hak: <strong style={{ color: '#374151' }}>{bakiye.hak}</strong></span>
              <span style={{ fontSize: 11, color: '#6b7280' }}>Kullanılan: <strong style={{ color: '#991b1b' }}>{bakiye.kullanilan}</strong></span>
              <span style={{ fontSize: 11, color: '#6b7280' }}>Kalan: <strong style={{ color: '#065f46', fontSize: 16 }}>{bakiye.kalan}</strong></span>
            </div>
            <div style={{ background: '#e5e7eb', borderRadius: 999, height: 6, marginTop: 6, overflow: 'hidden' }}>
              <div style={{ width: `${Math.min(100, (bakiye.kullanilan / bakiye.hak) * 100)}%`, height: '100%', background: '#065f46', borderRadius: 999 }} />
            </div>
          </div>
        ) : <OzetKart label="Personel Seçin" deger="—" renk="#9ca3af" bg="#f9fafb" />}
      </div>

      {/* FİLTRELER */}
      <div style={{ display: 'flex', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
        <select value={filtre.personel_id} onChange={e => filtreDegistir('personel_id', e.target.value)} style={{ ...selectSt, maxWidth: 260 }}>
          <option value="">Tüm Personel</option>
          {personeller.map(p => <option key={p.id} value={p.id}>{p.ad} {p.soyad} ({p.sicil_no})</option>)}
        </select>
        <select value={filtre.izin_turu} onChange={e => filtreDegistir('izin_turu', e.target.value)} style={selectSt}>
          <option value="">Tüm İzin Türleri</option>
          {Object.entries(IZIN_TUR).map(([k, v]) => <option key={k} value={k}>{v.ikon} {v.label}</option>)}
        </select>
        <select value={filtre.onay_durum} onChange={e => filtreDegistir('onay_durum', e.target.value)} style={selectSt}>
          <option value="">Tüm Durumlar</option>
          {Object.entries(ONAY_DURUM).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
      </div>

      {/* İZİN TÜRLERİ BİLGİ ŞERIDI */}
      <div style={{ display: 'flex', gap: 6, marginBottom: 16, flexWrap: 'wrap' }}>
        {Object.entries(IZIN_TUR).map(([k, v]) => (
          <div key={k} style={{ background: v.bg, color: v.renk, fontSize: 11, padding: '3px 10px', borderRadius: 20, fontWeight: 600, cursor: 'default' }}
            title={v.mevzuat}>
            {v.ikon} {v.label}
          </div>
        ))}
      </div>

      {/* LİSTE */}
      <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e5e7eb', overflow: 'hidden' }}>
        {liste.length === 0 ? (
          <div style={{ padding: 40, textAlign: 'center', color: '#9ca3af' }}>İzin kaydı bulunamadı.</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <thead>
              <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb' }}>
                {['Personel', 'İzin Türü', 'Başlangıç', 'Bitiş', 'Gün', 'Vekil', 'Durum', 'İşlem'].map(h => (
                  <th key={h} style={{ padding: '10px 14px', textAlign: 'left', fontWeight: 600, color: '#374151', fontSize: 12 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {liste.map((iz, i) => {
                const t = IZIN_TUR[iz.izin_turu] || { label: iz.izin_turu, renk: '#374151', bg: '#f3f4f6', ikon: '•' };
                const d = ONAY_DURUM[iz.onay_durum] || { label: iz.onay_durum, renk: '#374151', bg: '#f3f4f6' };
                return (
                  <tr key={iz.id} style={{ borderBottom: '1px solid #f3f4f6', background: iz.onay_durum === 'beklemede' ? '#fffbeb' : i % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={{ padding: '9px 14px', fontWeight: 600 }}>{iz.personel_adi || `#${iz.personel_id}`}</td>
                    <td style={{ padding: '9px 14px' }}>
                      <span style={{ background: t.bg, color: t.renk, fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 6 }}>
                        {t.ikon} {t.label}
                      </span>
                    </td>
                    <td style={{ padding: '9px 14px', fontFamily: 'monospace', fontSize: 12 }}>{iz.baslama_tarihi}</td>
                    <td style={{ padding: '9px 14px', fontFamily: 'monospace', fontSize: 12 }}>{iz.bitis_tarihi}</td>
                    <td style={{ padding: '9px 14px', textAlign: 'center', fontWeight: 700 }}>{iz.gun_sayisi}</td>
                    <td style={{ padding: '9px 14px', color: '#6b7280', fontSize: 12 }}>{iz.vekil_adi || '—'}</td>
                    <td style={{ padding: '9px 14px' }}>
                      <span style={{ background: d.bg, color: d.renk, fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 6 }}>{d.label}</span>
                    </td>
                    <td style={{ padding: '9px 14px' }}>
                      <div style={{ display: 'flex', gap: 4 }}>
                        {iz.onay_durum === 'beklemede' && <>
                          <button onClick={() => onayla(iz.id)} style={{ ...kücükBtnSt, color: '#065f46', borderColor: '#86efac' }}>✓ Onayla</button>
                          <button onClick={() => reddet(iz.id)} style={{ ...kücükBtnSt, color: '#991b1b', borderColor: '#fecaca' }}>✗ Reddet</button>
                        </>}
                        <button onClick={() => setForm({ ...iz })} style={kücükBtnSt}>Düzenle</button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* FORM MODALI */}
      {form && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 28, width: 580, maxHeight: '90vh', overflow: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700 }}>{form.id ? 'İzin Güncelle' : 'İzin Talebi Ekle'}</h3>
              <button onClick={() => setForm(null)} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#9ca3af' }}>✕</button>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
              <Alan etiket="Personel *" tam>
                <select value={form.personel_id} onChange={e => setForm({ ...form, personel_id: e.target.value })} style={selectSt}>
                  <option value="">Seçiniz</option>
                  {personeller.map(p => <option key={p.id} value={p.id}>{p.ad} {p.soyad} ({p.sicil_no})</option>)}
                </select>
              </Alan>
              <Alan etiket="İzin Türü *">
                <select value={form.izin_turu} onChange={e => setForm({ ...form, izin_turu: e.target.value })} style={selectSt}>
                  {Object.entries(IZIN_TUR).map(([k, v]) => <option key={k} value={k}>{v.ikon} {v.label} ({v.mevzuat})</option>)}
                </select>
              </Alan>
              <Alan etiket="Başlangıç Tarihi *">
                <input type="date" value={form.baslama_tarihi} onChange={e => {
                  const gun = gunHesapla(e.target.value, form.bitis_tarihi);
                  setForm({ ...form, baslama_tarihi: e.target.value, gun_sayisi: gun });
                }} style={inputSt} />
              </Alan>
              <Alan etiket="Bitiş Tarihi *">
                <input type="date" value={form.bitis_tarihi} onChange={e => {
                  const gun = gunHesapla(form.baslama_tarihi, e.target.value);
                  setForm({ ...form, bitis_tarihi: e.target.value, gun_sayisi: gun });
                }} style={inputSt} />
              </Alan>
              <Alan etiket="Gün Sayısı">
                <input type="number" min={1} value={form.gun_sayisi} onChange={e => setForm({ ...form, gun_sayisi: e.target.value })} style={inputSt} />
              </Alan>
              <Alan etiket="Vekil Adı">
                <input value={form.vekil_adi} onChange={e => setForm({ ...form, vekil_adi: e.target.value })} style={inputSt} placeholder="Görev vekilinin adı" />
              </Alan>
              <Alan etiket="Açıklama" tam>
                <textarea value={form.aciklama} onChange={e => setForm({ ...form, aciklama: e.target.value })} style={{ ...inputSt, height: 70, resize: 'vertical' }} />
              </Alan>
            </div>
            {form.baslama_tarihi && form.bitis_tarihi && (
              <div style={{ background: '#eff6ff', borderRadius: 8, padding: '10px 14px', marginTop: 10, fontSize: 13, color: '#1e40af', fontWeight: 600 }}>
                📅 {form.gun_sayisi} iş günü izin
              </div>
            )}
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 }}>
              <button onClick={() => setForm(null)} style={{ padding: '9px 20px', border: '1px solid #d1d5db', borderRadius: 8, background: '#f3f4f6', color: '#374151', cursor: 'pointer', fontWeight: 600 }}>İptal</button>
              <button onClick={kaydet} style={{ padding: '9px 20px', border: 'none', borderRadius: 8, background: '#1d4ed8', color: '#fff', cursor: 'pointer', fontWeight: 600 }}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function gunHesapla(bas: string, bit: string) {
  if (!bas || !bit) return 0;
  const d1 = new Date(bas), d2 = new Date(bit);
  return Math.max(0, Math.round((d2.getTime() - d1.getTime()) / 86400000) + 1);
}

function OzetKart({ label, deger, renk, bg }: { label: string; deger: any; renk: string; bg: string }) {
  return (
    <div style={{ background: bg, borderRadius: 10, padding: '12px 16px', textAlign: 'center', border: '1px solid #e5e7eb' }}>
      <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 26, fontWeight: 700, color: renk }}>{deger}</div>
    </div>
  );
}

function Alan({ etiket, tam, children }: { etiket: string; tam?: boolean; children: React.ReactNode }) {
  return (
    <div style={{ gridColumn: tam ? '1 / -1' : undefined }}>
      <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>{etiket}</label>
      {children}
    </div>
  );
}

const inputSt: React.CSSProperties = { width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 7, fontSize: 13, boxSizing: 'border-box' };
const selectSt: React.CSSProperties = { ...inputSt, background: '#fff' };
const kücükBtnSt: React.CSSProperties = { background: 'none', border: '1px solid #d1d5db', borderRadius: 6, padding: '3px 8px', cursor: 'pointer', fontSize: 11, color: '#374151' };
